import { render, staticRenderFns } from "./EmployeesSliceTable.vue?vue&type=template&id=4e260d16&"
import script from "./EmployeesSliceTable.vue?vue&type=script&lang=js&"
export * from "./EmployeesSliceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports